import { atom } from 'jotai';

export const regulatoryGuidelineWarningModalOpenAtom = atom(false);
